import React, {PureComponent} from 'react';
import { Button, Row, Col } from 'antd';
//import DimioSlidein from '../../../components/DimioSlidein';
import Dimio from '../../../components/Dimio';

import moment from 'moment';
import config from '../config/config';

import _ from 'lodash';

class BlogItem extends PureComponent{
  constructor(props) {
    super(props);

    this.state = {
      thumb: false
    };

    this.readMore = this.readMore.bind(this);
  }

  componentDidMount() {
    const {item} = this.props;

    const dimio = new Dimio();

    if(item.featured_media) {
      const url = 'https://tora-tora.net/weblog/wp-json/wp/v2/media/'+item.featured_media;
      const opt = {query: ''};
      dimio.load2(url, opt).then(res => {
        if(_.has(res, 'media_details.sizes.medium.source_url')){
          this.setState({thumb: res.media_details.sizes.medium.source_url});
        }
      });
    }
  }

  readMore(){
//    this.setState({show: true});
//    console.info(this.panel);
    this.panel.openPanel();
  }

  render(){
    const {item, index, showDetail} = this.props;
    const {thumb} = this.state;

    return(
      <div className='school-blog-item'>
        {thumb &&
        <img className='school-blog-item__img rounded border' src={thumb} alt=""/>
        }
        <h2 className='school-blog-item__title'>{item.title.rendered}</h2>
        {/*
        <Row className='mb-1'>
          <Col xs={12}>

          </Col>
          <Col xs={12}>
            <time className='float-right' style={{fontSize:'0.9rem'}}>{moment(item.modified).format('YYYY-MM-DD')}</time>
          </Col>
        </Row>
        */}
        <div className="">
          <Button
            onClick={(e) => showDetail(item, index, e)}
            className="btn btn-outline-primary btn-block btn-xs"
          >続きを読む</Button>
        </div>
      </div>
    );
  }
}

export default BlogItem;



// WEBPACK FOOTER //
// ./src/pages/school_blog/components/BlogItem.js